import { AxiosResponse } from "axios";
import { endPoints } from "utils/constants";
import { crudService } from "services/crud.service";
import { NotificationManager } from "react-notifications";
import { defaultMetaObj, initialSourceState } from "store/constants";
import { getErrorMessage, getPaginatedUrlWithSearchParams } from "store/helper";
import { createAsyncThunk, PayloadAction, createSlice } from "@reduxjs/toolkit";

const { sourceEndPoint } = endPoints;

export const fetchAllSource = createAsyncThunk(
  "source/fetchAllSource",
  async (
    {
      page,
      limit,
      searchParamsObj = {},
    }: { page: number; limit?: number; searchParamsObj?: {} },
    { rejectWithValue }
  ) => {
    const paginatedUrl = getPaginatedUrlWithSearchParams({
      pageNumber: page,
      limit,
      endpoint: sourceEndPoint,
      searchParams: { ...searchParamsObj },
    });
    try {
      const response: AxiosResponse = await crudService.getAll(paginatedUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addSource = createAsyncThunk(
  "source/addSource",
  async (newSource: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse = await crudService.create(
        `${sourceEndPoint}/`,
        newSource
      );

      if (response.status === 201) {
        NotificationManager.success("Source Created Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSource = createAsyncThunk(
  "source/deleteSource",
  async ({ sourceId }: any, { rejectWithValue }) => {
    try {
      const response: any = await crudService.delete(sourceEndPoint, sourceId);

      if (response.status === 204) {
        NotificationManager.success("Source Deleted Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

export const updateSource = createAsyncThunk(
  "source/updateSource",
  async ({ updatedSource, sourceId }: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse = await crudService.update(
        sourceEndPoint,
        sourceId,
        updatedSource
      );
      if (response.status === 204) {
        NotificationManager.success("Source updated Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

const sourceSlice = createSlice({
  name: "source",
  initialState: initialSourceState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch all source
    builder
      .addCase(fetchAllSource.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        fetchAllSource.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.source = action.payload.objects as any[];
          state.meta = action.payload?.meta;
        }
      )
      .addCase(
        fetchAllSource.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
          state.meta = defaultMetaObj;
        }
      );

    // add source

    builder
      .addCase(addSource.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(addSource.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
      })
      .addCase(addSource.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // delete source
    builder
      .addCase(deleteSource.pending, (State) => {
        State.loading = true;
      })
      .addCase(deleteSource.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
      })
      .addCase(
        deleteSource.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );

    //   update source
    builder
      .addCase(updateSource.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        updateSource.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
        }
      )
      .addCase(
        updateSource.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );
  },
});

export const sourceReducer = sourceSlice.reducer;
